import { session } from '@/api/session'
import { useAuth } from '@/auth/use-auth'

/**
 * The branch every tile on this screen reads for, unless a tile has no branch to scope by.
 *
 * The same resolution the collection worklist and the posting screens use: the branch picked in
 * the header if one has been picked, the signed-in user's home branch otherwise. Never the
 * server's institution-wide answer by default — a "morning screen" is a branch operator's own
 * branch until they choose to look at another one, and nothing here offers that choice yet.
 */
export function useOperatorBranchId(): string | null {
  const { user } = useAuth()
  return session.getBranchId() ?? user?.homeBranchId ?? null
}
